import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection } from 'lexical';
import { Omega } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ToolbarMenu } from '../../ui/ToolbarMenu';

/** The glyphs Froala's `specialCharacters` plugin offers, trimmed to the sets people actually use. */
// prettier-ignore
const SPECIAL_CHARACTERS = [
  '€', '£', '$', '¢', '¥', '©', '®', '™', '°', '±',
  '×', '÷', '≠', '≈', '≤', '≥', '∞', '√', '∑', 'µ',
  'α', 'β', 'γ', 'δ', 'π', 'Ω', '½', '¼', '¾', '‰',
  '§', '¶', '†', '‡', '•', '…', '–', '—', '«', '»',
  '“', '”', '‘', '’', '→', '←', '↑', '↓', '✓', '✗',
];

export const SpecialCharactersControl = ({ disabled }: { disabled: boolean }) => {
  const [editor] = useLexicalComposerContext();
  const { t } = useTranslation('common');

  return (
    <ToolbarMenu icon={Omega} caret="none" disabled={disabled} label={t('editor.toolbar.special-characters')}>
      {(close) => (
        <div className="grid w-64 grid-cols-10 gap-0.5 p-2">
          {SPECIAL_CHARACTERS.map((char) => (
            <button
              key={char}
              type="button"
              title={char}
              className="hover:bg-background-mid-1 flex size-5.5 cursor-pointer items-center justify-center rounded"
              onClick={() => {
                editor.update(() => {
                  const selection = $getSelection();
                  if ($isRangeSelection(selection)) selection.insertText(char);
                });
                close();
              }}
            >
              {char}
            </button>
          ))}
        </div>
      )}
    </ToolbarMenu>
  );
};
